export default __webpack_public_path__ + "static/media/iconLatency.2af33b6f.svg";